import React, { useEffect, useState } from 'react';
import { formatSeoApiError, listSeoApiFailures } from '../../../utils/adminSeo';

export default function SeoApiFailuresScreen() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    listSeoApiFailures({ limit: 80 })
      .then((r) => setRows(r.failures || []))
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Failed API Calls</h2>
      {err && <p className="text-red-600 text-sm">{err}</p>}
      <div className="bg-white border rounded overflow-x-auto max-h-[70vh]">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 sticky top-0">
            <tr>
              <th className="p-2">Time</th>
              <th className="p-2">Source</th>
              <th className="p-2">Entity</th>
              <th className="p-2 text-left">Error</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t">
                <td className="p-2 text-xs">{String(r.timestamp || '').slice(0, 19)}</td>
                <td className="p-2">{r.source}</td>
                <td className="p-2 text-xs">
                  {r.entity_type}/{r.entity_key}
                </td>
                <td className="p-2 text-xs text-red-700">{r.error}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
